import { isAllCitiesSelection } from '../../helpers/allCitiesOfCountry';
import { normalizeContactDigits } from '../../helpers/organizationAutofill';
import { CITY_MODES, CONTACT_FIELDS } from '../../helpers/eventsBulkAutofill';

export const FIELD_TYPES = {
  text: 'text',
  textarea: 'textarea',
  date: 'date',
  holdingDates: 'holdingDates',
  contact: 'contact',
  category: 'category',
  city: 'city',
  address: 'address',
  coordinates: 'coordinates',
  languages: 'languages',
  isForAllLanguages: 'isForAllLanguages',
  photoUrls: 'photoUrls',
};

export const EVENT_FIELDS = [
  { key: 'ownerId', label: 'ID владельца', type: FIELD_TYPES.text },
  { key: 'name', label: 'Название', type: FIELD_TYPES.text },
  { key: 'category', label: 'Категория', type: FIELD_TYPES.category },
  { key: 'holdingDates', label: 'Дни проведения', type: FIELD_TYPES.holdingDates },
  { key: 'holdingTime', label: 'Время', type: FIELD_TYPES.text },
  { key: 'dateStart', label: 'Дата начала', type: FIELD_TYPES.date },
  { key: 'dateEnd', label: 'Дата окончания', type: FIELD_TYPES.date },
  { key: 'city', label: 'Город', type: FIELD_TYPES.city },
  { key: 'address', label: 'Адрес', type: FIELD_TYPES.address },
  { key: 'coordinates', label: 'Координаты', type: FIELD_TYPES.coordinates },
  ...CONTACT_FIELDS.map((contact) => ({
    key: `contacts.${contact.key}`,
    label: contact.label,
    type: FIELD_TYPES.contact,
    contactKey: contact.key,
    digitsOnly: contact.digitsOnly,
  })),
  { key: 'description', label: 'Описание', type: FIELD_TYPES.textarea },
  { key: 'is_for_all_languages', label: 'Для всех языков', type: FIELD_TYPES.isForAllLanguages },
  { key: 'languages', label: 'Языки', type: FIELD_TYPES.languages },
  { key: 'photoUrls', label: 'Фото по ссылке', type: FIELD_TYPES.photoUrls },
];

export function isFieldLocked(field, config) {
  if (!field) return false;
  switch (field.key) {
    case 'ownerId':
      return true;
    case 'category':
      return Boolean(config?.category);
    case 'city':
      return Boolean(config?.country) && config?.cityMode !== CITY_MODES.perOffer;
    default:
      return false;
  }
}

export function isFieldIrrelevant(field, draft) {
  if (!field || !draft) return false;
  if (isAllCitiesSelection(draft.city) && ['address', 'coordinates'].includes(field.key)) {
    return true;
  }
  return false;
}

export function getFieldValue(draft, field) {
  if (!draft || !field) return undefined;
  if (field.type === FIELD_TYPES.contact) return draft.contacts?.[field.contactKey] || '';
  return draft[field.key];
}

export function applyFieldValue(draft, field, value) {
  if (!field) return draft;

  if (field.type === FIELD_TYPES.contact) {
    const clean = field.digitsOnly ? normalizeContactDigits(value) : String(value ?? '').trim();
    const contacts = { ...(draft.contacts || {}) };
    if (clean) contacts[field.contactKey] = clean;
    else delete contacts[field.contactKey];
    return { ...draft, contacts };
  }

  if (field.type === FIELD_TYPES.city) {
    const patch = { city: value || null };
    if (isAllCitiesSelection(value)) {
      patch.address = '';
      patch.coordinates = null;
    }
    return { ...draft, ...patch };
  }

  if (field.key === 'is_for_all_languages' && value) {
    return { ...draft, is_for_all_languages: true };
  }

  return { ...draft, [field.key]: value };
}
